var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "840.000000pt",
    height: "859.000000pt",
    viewBox: "0 0 840.000000 859.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,859.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3241 8545 c-205 -45 -371 -141 -484 -280 -118 -145 -196 -389 -197 -612 l0 -72 -692 -3 -693 -3 -55 -26 c-101 -48 -178 -150 -188 -251 l-5 -48 -163 0 -164 0 0 -325 0 -325 3610 0 3610 0 0 325 0 325 -164 0 -164 0 -6 44 c-10 62 -60 159 -102 195 -19 17 -58 43 -87 59 l-52 27 -692 3 -691 3 -6 87 c-15 218 -69 404 -155 534 -119 179 -297 294 -534 344 -99 20 -1829 19 -1926 -1z m1810 -668 c25 -10 58 -30 72 -45 31 -32 57 -124 57 -199 l0 -53 -975 0 -975 0 0 38 c0 55 26 167 46 197 9 14 31 33 48 42 75 40 113 42 911 40 711 -2 774 -4 816 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254 6257 c-2 -7 -3 -1216 -1 -2687 3 -2433 4 -2681 19 -2745 93 -398 372 -680 763 -771 77 -18 163 -19 2180 -19 l2100 0 97 27 c191 53 346 144 479 284 36 38 79 89 96 114 79 117 142 282 163 425 8 58 10 803 8 2730 l-3 2650 -2948 3 c-2381 2 -2949 0 -2953 -11z m1966 -2947 l0 -1970 -327 2 -328 3 -3 1968 -2 1967 330 0 330 0 0 -1970z m1318 3 l-3 -1968 -327 -3 -328 -2 0 1970 0 1970 330 0 330 0 -2 -1967z m1312 -3 l0 -1970 -330 0 -330 0 0 1970 0 1970 330 0 330 0 0 -1970z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.746f54252b0375dc516e2e1a7d12ceb0.svg";
export { ForwardRef as ReactComponent };